import JsonApiCollection from "../JsonApiCollection";

export class JsonApiCollectionStore extends JsonApiCollection {
  constructor(...args) {
    super(...args);
    this._subscribers = new Set();
    this._pauseNotifications = 0;
  }
  _notifySubscribers() {
    for (const fn of this._subscribers) {
      fn(this);
    }
  }
  subscribe(fn) {
    this._subscribers.add(fn);
    fn(this);
    return () => this._subscribers.delete(fn);
  }
  reset(...args) {
    const result = super.reset(...args);
    // reset gets called during initialization, so it has to be ok with not having _subscribers yet
    if(!this._pauseNotifications && this._subscribers) this._notifySubscribers();
    return result;
  }
  delete(...args) {
    const wasPresent = super.delete(...args);
    if (wasPresent && !this._pauseNotifications) this._notifySubscribers();
    return wasPresent;
  }
  add(...args) {
    const result = super.add(...args);
    if(!this._pauseNotifications) this._notifySubscribers();
    return result;
  }
  _sort() {
    if (!this._pauseNotifications) super._sort();
  }
  batch(fn) {
    let result
    this._pauseNotifications += 1;
    try {
      result = fn(this);
    } finally {
      this._pauseNotifications -= 1;
    }
    this._sort();
    this._notifySubscribers();
    return result;
  }
}

export default JsonApiCollectionStore;